import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchVerifyOtp } from "./forgetPassApi";

export interface VerifyOtpState {
  otp: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: VerifyOtpState = {
  otp: [],
  status: "idle",
};

export const GetVerifyOtp = createAsyncThunk(
  "verifyOtp",
  async (data: any) => {
    const response = await fetchVerifyOtp(data);
    return response;
  }
);

export const verifyOtpSlice = createSlice({
  name: "verifyOtp",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetVerifyOtp.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetVerifyOtp.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetVerifyOtp.fulfilled, (state, action) => {
        state.status = "success";
        state.otp = action.payload.verifyOtp;
      });
  },
});

export const {} = verifyOtpSlice.actions;

export const selectVerifyOtpPass = (state: RootState) => {
  return state.verifyOtpSubmit.otp;
};

export default verifyOtpSlice.reducer;
